import { render, staticRenderFns } from "./NuevaMarca.vue?vue&type=template&id=7e74da24&"
import script from "./NuevaMarca.vue?vue&type=script&lang=js&"
export * from "./NuevaMarca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports